import anime from 'animejs/lib/anime.es.js';

export default function(el) {
	return new Promise(resolve => {
		const bg = el.querySelector('.c-slide-text__bg');
		const text = el.querySelector('.c-slide-text__text');
		const tl = anime
			.timeline({
				easing: 'linear',
				duration: 300,
			})
			.add({
				targets: text,
				opacity: 0,
			})
			.add({
				targets: bg,
				translateX: ['0%', '100%'],
				easing: 'easeInOutCubic',
				duration: 800,
			});

		tl.finished.then(resolve);
	});
}
